module.exports = __webpack_public_path__ + "static/slider-bg-1-4af5dae877f505ac96410120232e64c4.jpg";